var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26667 25C3.77319 25 3.02646 25 2.45603 24.7094C1.95426 24.4537 1.54631 24.0457 1.29065 23.544C1 22.9735 1 22.2268 1 20.7333L1 19.9333C1 18.4399 1 17.6931 1.29065 17.1227C1.54631 16.6209 1.95426 16.213 2.45603 15.9573C3.02646 15.6667 3.77319 15.6667 5.26667 15.6667L20.7333 15.6667C22.2268 15.6667 22.9735 15.6667 23.544 15.9573C24.0457 16.213 24.4537 16.6209 24.7094 17.1227C25 17.6931 25 18.4399 25 19.9333V20.7333C25 22.2268 25 22.9735 24.7094 23.544C24.4537 24.0457 24.0457 24.4537 23.544 24.7093C22.9735 25 22.2268 25 20.7333 25H5.26667Z",
    stroke: "#444CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26667 10.3333C3.77319 10.3333 3.02646 10.3333 2.45603 10.0427C1.95426 9.78702 1.54631 9.37907 1.29065 8.87731C1 8.30688 1 7.56014 1 6.06667L1 5.26667C1 3.77319 1 3.02646 1.29065 2.45603C1.54631 1.95426 1.95426 1.54631 2.45603 1.29065C3.02646 1 3.77319 1 5.26667 1L20.7333 1C22.2268 1 22.9735 1 23.544 1.29065C24.0457 1.54631 24.4537 1.95426 24.7094 2.45603C25 3.02646 25 3.77319 25 5.26667V6.06667C25 7.56014 25 8.30688 24.7094 8.87731C24.4537 9.37907 24.0457 9.78702 23.544 10.0427C22.9735 10.3333 22.2268 10.3333 20.7333 10.3333L5.26667 10.3333Z",
    stroke: "#444CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionsIcon);
export default __webpack_public_path__ + "static/media/sections_icon.f6af0b17aa90d5b36c838f13eb1b8549.svg";
export { ForwardRef as ReactComponent };